import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Presidio auth modals — check / warning icons matching Formly validation-icons.
 */
@Component({
  selector: 'ish-auth-field-validation-icons',
  template: `
    @if (showError()) {
    <span class="has-feedback">
      <i
        class="form-control-feedback bi bi-exclamation-triangle-fill"
        data-testing-id="exclamation-triangle-icon"
        aria-hidden="true"
      ></i>
    </span>
    } @else if (showSuccess()) {
    <span class="has-feedback has-success">
      <i class="form-control-feedback bi bi-check-lg" data-testing-id="check-icon" aria-hidden="true"></i>
    </span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthFieldValidationIconsComponent {
  readonly showError = input(false);
  readonly showSuccess = input(false);
}
